import React, { useCallback, useEffect, useState } from 'react';

import { useApolloClient } from '@apollo/client';
import { useIntl } from 'react-intl';

import useGraphaelDefaults from 'hooks/useGraphaelDefaults';
import useStaticValues from 'hooks/useStaticValues';

import sacHeader from 'assets/images/sexual-ansiety-course/header.webp';

import AudioCourse, { AudioCourseStory } from '../AudioCourse';
import { buildMultiStoryQuery } from '../AudioCourse/helpers';


export const SAC_TRACKING_NAME = 'SexualAnxietyClass';
export const SAC_ROUTE = 'sexual-anxiety-class';

const SexualAnxietyClass = () => {
  const { locale } = useIntl();
  const { sexualAnxietyClass } = useStaticValues({ locale });

  const apolloClient = useApolloClient();
  const defaults = useGraphaelDefaults();
  const [audios, setAudios] = useState<AudioCourseStory[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchCourseAudios = useCallback(async () => {
    try {
      const { data } = await apolloClient.query<AudioCourseStory[]>({
        ...defaults,
        query: buildMultiStoryQuery(sexualAnxietyClass.audios),
      });

      const storiesArray = Object.values(data);

      setAudios(storiesArray);
    } catch (error) {
      /* ignore the error */
    } finally {
      setLoading(false);
    }
  }, [apolloClient, defaults, sexualAnxietyClass.audios]);

  const title = { id: 'components.sac.title' };
  const description = { id: 'components.sac.description' };
  const illustration = {
    src: sacHeader,
    alt: { id: 'components.sac.home.cover.alt' },
  };

  useEffect(() => {
    fetchCourseAudios();
    // we dont want this use effect entering on a loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return null;
  }

  return (
    <AudioCourse
      illustration={illustration}
      title={title}
      description={description}
      audios={audios}
    />
  );
};

export default SexualAnxietyClass;
